import * as React from "react";
import styled from "@emotion/styled";
import { ArtistPostHeading } from "features/reviewable/components/ArtistPostHeading";
import type { Image } from "features/images";
import type { Post } from "../types";
import { PostCard } from "./PostCard";

type FeedProps = {
  /**
   * Array of Posts, returns null if array is empty
   */
  posts: Post[];
  showArtist?: boolean;
  hideFollow?: boolean;
  /**
   * Optional node to display a load more button, for example
   */
  footer?: React.ReactNode;
};

/**
 * Purely resentational component to display an array of PostCards
 */
function Feed({ posts, showArtist, hideFollow, footer, ...props }: FeedProps) {
  if (!posts.length) return null;

  return (
    <>
      <FeedGrid {...props}>
        {posts.map((post) => (
          <PostCard
            key={post.id}
            post={post}
            artistHeader={
              <ArtistHeader
                showArtist={showArtist}
                hideFollow={hideFollow}
                artistId={post.destinations[0].feedId}
                artistName={post.artistName}
                artistIcon={post.artistIcon}
              />
            }
          />
        ))}
      </FeedGrid>

      {footer && <Footer>{footer}</Footer>}
    </>
  );
}

const FeedGrid = styled.div(({ theme }) => ({
  display: "grid",
  gap: theme.spacing.gap,
  gridTemplateColumns: "repeat(auto-fill, minmax(275px, 1fr))",
}));

const Footer = styled.div({
  display: "flex",
  justifyContent: "center",
  margin: "2rem auto",
});

type ArtistHeaderProps = {
  showArtist?: boolean;
  hideFollow?: boolean;
  artistId: string;
  artistName?: string;
  artistIcon?: Image;
};

const ArtistHeader = React.memo(({ showArtist, ...props }: ArtistHeaderProps) =>
  showArtist ? <ArtistPostHeading {...props} /> : null
);

export { Feed };
